// extracted by mini-css-extract-plugin
export default {"text":"aXnoUE","external":"bXnoUE","linkColor":"cXnoUE","quote":"dXnoUE","listMarkdown":"eXnoUE"};